import React, { Component, createRef } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import './AppTransitionGroup.scss'

export default class AppTransitionGroup extends Component {
  constructor(props) {
    super(props)
    this.contentRef = createRef()
  }

  getTimeoutMs() {
    const { transitionSpeed = 3 } = this.props

    return transitionSpeed * 100
  }

  onEnter = () => {
    const node = this.contentRef.current
    if (!node) return

    node.style.maxHeight = '0px'
    node.style.opacity = '0'
    node.style.overflow = 'hidden'
  }

  onEntering = () => {
    const node = this.contentRef.current
    if (!node) return
    const timeout = this.getTimeoutMs()
    const height = node.scrollHeight
    node.style.transition = `max-height ${timeout}ms ease, opacity ${timeout}ms ease`
    node.style.maxHeight = `${height}px`
    node.style.opacity = '1'
  }

  onEntered = () => {
    const node = this.contentRef.current
    if (!node) return
    node.style.maxHeight = 'none'
    node.style.transition = ''
    node.style.overflow = ''
    node.style.opacity = ''
  }

  onExit = () => {
    const node = this.contentRef.current
    if (!node) return
    const height = node.scrollHeight
    node.style.maxHeight = `${height}px`
    node.style.opacity = '1'
    node.style.overflow = 'hidden'
  }

  onExiting = () => {
    const node = this.contentRef.current
    if (!node) return
    const timeout = this.getTimeoutMs()
    // eslint-disable-next-line no-void
    void node.offsetHeight
    node.style.transition = `max-height ${timeout}ms ease, opacity ${timeout}ms ease`
    node.style.maxHeight = '0px'
    node.style.opacity = '0'
  }

  onExited = () => {
    const node = this.contentRef.current
    if (!node) return
    node.style.maxHeight = ''
    node.style.transition = ''
    node.style.opacity = ''
    node.style.overflow = ''
  }

  render() {
    const { in: expanded, children, transitionSpeed, ...rest } = this.props
    const timeout = this.getTimeoutMs()

    return (
      <>
        <TransitionGroup>
          {expanded && (
            <CSSTransition
              in={expanded}
              timeout={timeout}
              classNames="accordion-transition"
              unmountOnExit
              nodeRef={this.contentRef}
              onEnter={this.onEnter}
              onEntering={this.onEntering}
              onEntered={this.onEntered}
              onExit={this.onExit}
              onExiting={this.onExiting}
              onExited={this.onExited}
              {...rest}
            >
              <div
                className="accordion-children accordion-content"
                ref={this.contentRef}
              >
                <div className="accordion-children-wrapper">{children}</div>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
      </>
    )
  }
}
